import React, { useState } from 'react'
import axios from "axios";


const Register = () => {

    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [cpassword, setcPassword] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    //const [isAdmin,setIsAdmin] = useState(true);
    const [err, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== cpassword) {
            alert("Please password does not match");
            return;
        }
        try {
            const req = { name, password, email, phone };
            //console.log(req)
            const res = await axios.post("https://elo.projectdriveng.com.ng/api/Account/Register", req);
            res.data && window.location.replace("/login");

        } catch (error) {
            setError("Could not register, please check your details or contact us")
            console.log(error)
        }
    }
    const handlecp = (e) => {
        setcPassword(e.target.value);
    }
    return (
        <>
            <section className="vh-100" style={{ backgroundColor: "#eee" }}>
                <div className="container h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-lg-12 col-xl-11">
                            <div className="card text-black">
                                <div className="card-body p-md-5">
                                    <div className="row justify-content-center">
                                        <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">

                                            <p className="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">Sign up</p>
                                            {err && <p style={{ color: "red" }}>{err}</p>}
                                            <form className="mx-1 mx-md-4" onSubmit={handleSubmit}>

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label className="form-label" htmlFor="form3Example1c">Your Name</label>
                                                        <input type="text" id="form3Example1c" placeholder='Enter your name' onChange={e => setName(e.target.value)} className="form-control" />
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label className="form-label" htmlFor="form3Example1c">Your Phone</label>
                                                        <input type="text" id="form3Example1c" placeholder='Phone' onChange={e => setPhone(e.target.value)} className="form-control" />
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-envelope fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label className="form-label" htmlFor="form3Example3c">Your Email</label>
                                                        <input type="email" id="form3Example3c" placeholder='Email' onChange={e => setEmail(e.target.value)} className="form-control" />
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-lock fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label className="form-label" htmlFor="form3Example4c">Password</label>
                                                        <input type="password" id="form3Example4c" placeholder='Password' onChange={e => setPassword(e.target.value)} className="form-control" />
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-key fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label className="form-label" htmlFor="form3Example4cd">Confirm your password</label>
                                                        <input type="password" placeholder='Re-type your password' onChange={handlecp} id="form3Example4cd" className="form-control" />                 
                                                    </div>
                                                </div>



                                                <div className="d-flex justify-content-center mx-4 mb-3 mb-lg-4">
                                                    <button type="submit" className="btn btn-primary btn-lg">Register</button>
                                                </div>

                                            </form>

                                        </div>
                                        <div className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">

                                            <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp" className="img-fluid" alt="Sample" />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Register;